import { chatBlobIoClientId, productReviewsImageUploadClientId } from 'constants/AppConstants';
import { OldApiCaller as ApiCaller } from './ApiCaller';
import baseAjaxConfig, { headers } from './BaseAjaxConfig';
export function getAuthToken() {
    return ApiCaller.get(Object.assign(Object.assign({}, baseAjaxConfig), { pathname: '/api/1/blobio/authenticate', action: '', headers: Object.assign(Object.assign({}, headers), { 'X-Flipkart-Client': 'blobio' }) })).then(resp => Promise.resolve(resp.RESPONSE), e => Promise.reject(e));
}
export function uploadImage(data, file, accessToken, onProgress, token, oneShot = false) {
    return oneShot
        ? ApiCaller.xhr({
            url: 'https://blobio.flipkart.net/v3/blobio/one-shot',
            method: 'POST',
            headers: {
                'X-Flipkart-Client': chatBlobIoClientId,
                'Content-Type': file.type,
                'X-Upload-Content-Type': file.type,
                'X-Upload-Content-Length': file.size.toString(),
                'X-user-agent': headers['X-user-agent'],
                'X-Access-Token': accessToken
            },
            data: file,
            onProgress
        }, token)
        : ApiCaller.xhr({
            url: 'https://blobio.flipkart.net/v3/blobio/image',
            method: 'PUT',
            headers: {
                'X-Flipkart-Client': productReviewsImageUploadClientId,
                'X-user-agent': headers['X-user-agent'],
                'X-Access-Token': accessToken
            },
            data,
            onProgress
        }, token);
}
export function deleteImage(resourceId, accessToken) {
    return ApiCaller.delete(Object.assign(Object.assign({}, baseAjaxConfig), { protocol: 'https', hostname: 'blobio.flipkart.net', pathname: '/v3/blobio', action: '', acceptErrors: true, acceptJson: false, query: {
            key: resourceId
        }, headers: {
            'X-Flipkart-Client': productReviewsImageUploadClientId,
            'X-user-agent': headers['X-user-agent'],
            'X-Access-Token': accessToken
        } })).then(resp => Promise.resolve(resp), e => Promise.reject(e));
}
